import Vue from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
